import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import cx from 'clsx';
import { Text } from '@mantine/core';

import TablerIconDynamic from '@/components/TablerIconDynamic';
import classes from './private-layout.module.css';

type MenuLinkProps = {
  icon: string;
  title: string;
} & NavLinkProps;

const MenuLink: React.FC<MenuLinkProps> = ({ icon, title, ...props }) => (
  <NavLink
    className={({ isActive }) => cx(classes.link, { [classes.active]: isActive })}
    {...props}
  >
    <TablerIconDynamic size="1.5rem" icon={icon} />
    <Text span>{title}</Text>
  </NavLink>
);

export default MenuLink;
